import { T, useT } from '@transifex/react';
import { VStack } from '@vidahealth/vida-ui';

import RecordsNotFoundImage from '@/assets/images/onboarding/records-not-found.svg';
import { useRulesEngine } from '@/modules/rulesEngine';
import { ContactSupport, CtaButton, Screen, ScreenHeading } from '@/modules/ui';

// The default (non-terminal) rendering of NotEligibleScreen, mirroring stylos's
// RecordsNotFoundPage: the NotFound illustration + "couldn't find your records"
// copy. Reached for the `NotFound_*`-style codes. The only action is Start Over
// (pick a different org) — retrying the same org isn't useful here.
export function RecordsNotFoundTemplate() {
  const t = useT();
  const { restartEligibility } = useRulesEngine();

  return (
    <Screen
      contentStyle={{ justifyContent: 'center' }}
      footer={
        <VStack space='md'>
          <ContactSupport showEmail showPhone />
          <CtaButton onPress={restartEligibility} testID='records-not-found-start-over'>
            <T _str='Start Over' />
          </CtaButton>
        </VStack>
      }
    >
      <VStack space='2xl' className='items-center'>
        <RecordsNotFoundImage width={138} height={166} />
        <ScreenHeading
          title={t("Sorry, but we couldn't find your records")}
          subtitle={t("Let's make sure that all of your information is correct and try again")}
          center
        />
      </VStack>
    </Screen>
  );
}
